<template>
    <div>
        <geometry-element
                :selectable="movingElement"
                :movable="isHexagonalModeling ? false : (!isReadOnly && movingElement) "
                :resizable="isHexagonalModeling ? false : (!isReadOnly && movingElement && isEditElement) "
                :deletable="isHexagonalModeling ? true : (!isReadOnly && isEditElement) "
                connectable
                :id.sync="elementCoordinate.id"
                :x.sync="elementCoordinate.x"
                :y.sync="elementCoordinate.y"
                :width.sync="elementCoordinate.width"
                :height.sync="elementCoordinate.height"
                :angle.sync="elementCoordinate.angle"
                :customMoveActionExist="isCustomMoveExist"
                v-on:customMoveAction="delayedMove"
                v-on:moveShape="onMoveShape"

                v-on:removeShape="onRemoveShape"
                v-on:dblclick="openPanel"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:rotateShape="onRotateShape"
                v-on:addedToGroup="onAddedToGroup"
                :label.sync="getFieldDescriptors ? '': namePanel"
                :image.sync="setImg"
                :_style="{
                'label-angle':value.elementView.angle,
                'font-weight': 'bold','font-size': '16'
                }"
        >

                <geometry-rect
                        v-if="movingElement"
                        :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#5099F7',
          fill: '#5099F7',
          'fill-opacity': 1,
          r: '1', 'z-index': '998'
        }"
                >
                </geometry-rect>
                <geometry-rect
                        v-else
                        :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#5099F7',
          fill: '#5099F7',
          'fill-opacity': .5,
          r: '1', 'z-index': '998'
        }"
                >
                </geometry-rect>

            <sub-elements v-if="!isHexagonalModeling"  v-for="(index) in newEditUserImg.length">
                <image-element
                        v-bind:image="newEditUserImg[index-1].picture"
                        :sub-width="'24px'"
                        :sub-height="'24px'"
                        :sub-right="(10*(index-1))+'px'"
                        :sub-bottom="value.elementView.height"
                >
                </image-element>
            </sub-elements>

            <sub-elements>
                <geometry-point
                        :coordinate="[95,5]"
                        :_style="statusCompleteStyle">
                </geometry-point>

                <!--title-->
                <image-element
                        v-if="showValidation"
                        v-bind:image="showValidationImg"
                        :sub-width="'20px'"
                        :sub-height="'20px'"
                        :sub-right="'5px'"
                        :sub-bottom="'5px'"
                >
                </image-element>

                <text-element
                        v-if="!isHexagonalModeling"
                        :sub-width="'100%'"
                        :sub-height="titleH"
                        :sub-top="0"
                        :sub-left="0"
                        :text="value.classReference ? value.classReference : '<< Command >>'">
                </text-element>

                <text-element
                        class="discStyle"
                        v-if="getFieldDescriptors"
                        :sub-width="'120%'"
                        :sub-height="detailHeight"
                        :sub-top="detailTop"
                        :sub-left="detailLeft"
                        :subStyle="{'font-size': '12px', 'text-anchor':'start'}"
                        :text="getFieldDescriptors">
                </text-element>

                <text-element
                        v-if="getFieldDescriptors && !isHexagonalModeling"
                        :sub-width="'100%'"
                        :sub-height="subjectHeight"
                        :sub-top="subjectTop"
                        :sub-left="0"
                        :subStyle="{'font-size': '16px', 'font-weight': 'bold'}"
                        :text="getNamePanel">
                </text-element>
                <storming-sub-controller :type="value._type" :value="value"
                                         :readOnly="isReadOnly"></storming-sub-controller>
            </sub-elements>
        </geometry-element>

        <command-definition-panel
                v-if="propertyPanel"
                v-model="value"
                :readOnly="!isEditElement"
                :newEditUserImg="newEditUserImg"
                :image="image"
                :validationLists="filteredElementValidationResults"
                :entities="entities"
                @close="closePanel"
                @changedPanelValue="changedPanelValue"
        ></command-definition-panel>
    </div>
</template>

<script>
    import CommandDefinitionPanel from "../panels/CommandDefinitionPanel";
    import Element from "./EventStormingModelElement";
    import SubElements from "../../../opengraph/shape/SubElements";

    var changeCase = require('change-case');
    var pluralize = require('pluralize');
    var _ = require('lodash')

    var Mustache = require('mustache')

    export default {
        mixins: [Element],
        name: 'command-definition',
        components:{SubElements, CommandDefinitionPanel},
        computed: {
            defaultStyle() {
                return {}
            },
            className() {
                return 'org.uengine.modeling.model.Command'
            },
            // elementPrefix(){
            //     var me = this
            //     if(me.copyValue.isRestRepository){
            //         return null
            //     }else{
            //         if(me.copyValue && me.copyValue.aggregate.name){
            //             var aggName = me.copyValue.aggregate.name
            //             return `/${pluralize(changeCase.camelCase(aggName))}/{id}/`;
            //         }else{
            //             return '/{ Aggregate }/{id}/'
            //         }
            //     }
            // },
            subjectTop() {
                return 30
            },
            subjectHeight() {
                return 8
            },
            detailHeight() {
                var count = null
                if(this.value.elementView.height <= 270){
                    count = this.commandfieldDescriptorsCount
                } else if(this.value.elementView.height > 270){
                    count = this.value.fieldDescriptors.length
                }
                return this.subjectHeight + (count * 5)
            },
            detailLeft() {
                var width = this.value.elementView.width * 0.1
                return width
            },
            detailTop() {
                return this.subjectTop + this.detailHeight
            },
            getFieldDescriptors() {

                if (this.value.fieldDescriptors) {
                    if (this.value.fieldDescriptors.length == 1
                        && this.value.fieldDescriptors[0].name == 'id') {
                        return false
                    }

                    var text = ''
                    var value = 0
                    if(this.value.elementView.height <= 100){
                        value = 42
                    } else if(this.value.elementView.height <= 150){
                        value = 30
                    } else if(this.value.elementView.height <= 270){
                        value = 23
                    } else if(this.value.elementView.height > 270){
                        value = 17
                    }
                    var y = Math.ceil(this.value.elementView.height/value)
                    this.commandfieldDescriptorsCount = y
                    if(this.value.fieldDescriptors.length > y){
                        for(var i = 0; i <= y; i++){
                            if(i == y) text = text + 'ㆍ ' + this.value.fieldDescriptors[i].name + '  ...'
                            else text = text + 'ㆍ ' + this.value.fieldDescriptors[i].name + '\n'
                        }
                    } else {
                        this.value.fieldDescriptors.forEach(function (field) {
                            text = text + 'ㆍ ' + field.name + '\n'
                        })
                    }
                    return text
                    
                }
                return null
            },
            createNew(elementId, x, y, width, height, description, label) {
                return {
                    _type: 'org.uengine.modeling.model.Command',
                    name: '',
                    oldName: '',
                    namePlural: '',
                    namePascalCase: '',
                    nameCamelCase: '',
                    description: null,
                    author: null,
                    aggregate: {},
                    boundedContext: {},

                    // alertURL: location.pathname + ((location.pathname == '/' || location.pathname.lastIndexOf('/') > 0) ? '' : '/') + 'static/image/symbol/alert-icon.png',
                    elementView: {
                        '_type': 'org.uengine.modeling.model.Command',
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({}),
                        'z-index': 999
                    },
                    hexagonalView:{
                        '_type': 'org.uengine.modeling.model.CommandHexagonal',
                        'id': elementId,
                        'x': 0,
                        'y': 0,
                        'width': 0,
                        'height': 0,
                        'style': JSON.stringify({})
                    },
                    //new pannel
                    isRestRepository: true,
                    controllerInfo: {
                        apiPath: '',
                        method: 'PUT'
                    },
                    restRepositoryInfo: {
                        method: 'POST'
                    },
                    relationEventInfo: [],
                    relationCommandInfo: [],
                    trigger: '@PostPersist',

                    fieldDescriptors: [],
                }
            }
        },
        data: function () {
            return {
                commandfieldDescriptorsCount: 0,
                itemH: 20,
                titleH: (this.value.classReference ? 60 : 30),
                reference: this.value.classReference != null,
                referenceClassName: this.value.classReference,

                entities: {},
            };
        },
        created: function () {
            // this.image = `${window.location.protocol + "//" + window.location.host}/static/image/event/command.png`
        },
        watch: {
            "value.restRepositoryInfo.method": function (newVal) {
                // Command 가 POST 면 PrePersist, DELETE 면  PreRemove, PATCH 면 PreUpdate
                if (newVal == "POST") {
                    this.value.trigger = "@PrePersist"
                } else if (newVal == "DELETE") {
                    this.value.trigger = "@PreRemove"
                } else if (newVal == "PATCH") {
                    this.value.trigger = "@PreUpdate"
                }
            },
            "value.controllerInfo.apiPath":function () {
                this.validate()
            },
        },
        methods: {
            validate(panelValue, executeRelateToValidate){
                var me = this
                var executeValidate = executeRelateToValidate == false ? false :true
                var validateValue = me.propertyPanel && panelValue ? panelValue : me.value

                // Common
                this.$super(Element).validate()

                // execute Relate Validate
                if(executeValidate) {

                }

                // Element
                if (me.canvasbase.attachedLists &&  Object.keys(me.canvasbase.attachedLists.aggregateLists).length > 0 ) {
                    me.attachedAggregate  = Object.values(me.canvasbase.attachedLists.aggregateLists).some(agg => {
                        if(me.isAggAttached(agg)){
                            var newAttachedAggregateId = agg.elementView.id

                            // 움직일때 AGG 변화 파악.
                            if(me.value && newAttachedAggregateId != me.attachedAggregateId){
                                // 서로 들다른 agg
                                me.attachedAggregateId = newAttachedAggregateId
                                me.canvasbase.changedTemplateCode = true
                            }

                            // validationResults
                            var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_AGG))
                            var isExistValidationResult = validationResultIndex == -1 ? false: true
                            if( isExistValidationResult ){
                                me.elementValidationResults.splice(validationResultIndex,1)
                            }
                            return true
                        }else{
                            // validationResults
                            var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_AGG) )
                            var isExistValidationResult = validationResultIndex == -1 ? false: true
                            if( !isExistValidationResult ){
                                me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_AGG))
                            }
                        }
                    })
                } else {
                    // validationResults
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_AGG) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_AGG))
                    }
                }


                if(validateValue.name){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME))
                    var isExistValidationResult = validationResultIndex == -1 ? false: true
                    if( isExistValidationResult ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME) )
                    var isExistValidationResult = validationResultIndex == -1 ? false: true
                    if( !isExistValidationResult ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_NAME))
                    }
                }


                if( !validateValue.isRestRepository && validateValue.controllerInfo.apiPath ){
                    // ESE_NOT_API_SPACING
                    var pattern = /\s/g;   // 공백 체크 정규표현식 - 탭, 스페이스
                    var specialPattern = /[`~!@#$%^&*|\\\'\";:\/?]/gi; // 특수 문제 체크 정규표현식
                    if( validateValue.controllerInfo.apiPath.match(pattern) ||  specialPattern.test(validateValue.controllerInfo.apiPath)){
                        var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_API_PATH_ERROR) )
                        if( validationResultIndex == -1 ){
                            me.elementValidationResults.push(me.validationFromCode(me.ESE_API_PATH_ERROR))
                        }
                    }else{
                        var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_API_PATH_ERROR))
                        if( validationResultIndex != -1 ){
                            me.elementValidationResults.splice(validationResultIndex,1)
                        }
                    }
                }else if(validateValue.isRestRepository){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_API_PATH_ERROR))
                    if( validationResultIndex != -1 ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }

            }
        }
    }
</script>




<style scoped lang="scss" rel="stylesheet/scss">
    .panel-title {
        font-size: 25px;
        color: #757575;
    }
</style>